import { Box } from '@ksyos/design-system';

export function ChartDottedLine(): JSX.Element {
    return (
        <Box
            alignItems="center"
            display="flex"
            gap={1}
            height={20}
            justifyContent="center"
            width={33}
        >
            <Box
                backgroundColor="neutral600"
                flex={1}
                height={2}
            />
            <Box
                backgroundColor="neutral600"
                flex={1}
                height={2}
            />
            <Box
                backgroundColor="neutral600"
                flex={1}
                height={2}
            />
        </Box>
    );
}
